<template>
  <td :class="column.decorator" :rowspan="rowspan" :style="getStyle()">
    <div v-if="(secondaryIndex === 0) || (column.path ? column.path : '').includes('[]')">
      <component
          :is="'tablefield-' + column.decorator"
          v-if="column.decorator !== 'composite' && checkField(column, product)"
          :class="[column.decorator]"
          :config="column"
          :data="getCellData(column, product, secondaryIndex)"
          :product="product"
          :singleLine="singleLine"
          name="base"
      ></component>
      <div v-else-if="column.decorator === 'composite'">
        <component
            :is="'tablefield-' + subField.decorator"
            v-for="(subField,index) in column.decoratorOptions.lines"
            v-if="checkField(subField, product)"
            :key="index"
            :class="subField.decorator"
            :config="subField"
            :data="getCellData(subField, product, secondaryIndex)"
            :product="product"
            :singleLine="singleLine"
        ></component>
        <div v-else :class="{'single-line':singleLine}">—</div>
      </div>
      <div v-else>—</div>
    </div>
    <div v-else></div>
  </td>
</template>

<script>
import TableFieldMixin
  from './FieldMixin'

export default {
  name: 'tablefield',
  props: ['column', 'product', 'secondaryIndex', 'rowspan', 'totalWeight', 'useLegacyFormatting', 'singleLine'],
  mixins: [TableFieldMixin],
  methods: {
    getCellData(column, product, multiRowIndex) {
      if (column.decorator === 'fallback') {
        return [...column.decoratorOptions.lines.map(el => this._.get(product, el.path, null))]
      }
      let path = column.path ? column.path.replace('[]', `[${multiRowIndex}]`) : ''
      return this._.get(product, path, undefined)
    },
    getStyle() {
      if (this.useLegacyFormatting) {
        return {}
      } else {
        return {width: ((this.column.weight || 1) / this.totalWeight * 100) + '%'}
      }
    },
    checkField(column, product) {
      if (column.decorator === 'boolean') {
        return true
      }
      const value = this.getCellData(column, product, this.secondaryIndex)
      return !this._.isUndefined(value) && !(value === null)
    },
  },
}
</script>



// WEBPACK FOOTER //
// FieldContainer.vue?3407a4ca